@if (!appSettings.isMobile()) {
  <div class="party-list-desktop">
    <div class="mb-2">
      <div class="input-group">
        <ng-select #ngSelect
          [items]="ngPartiesData()"
          [selectableGroup]="true"
          bindLabel="rutNames"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="true"
          [dropdownPosition]="'bottom'"
          bindValue="uuid"
          placeholder="Buscar Socio..."
          tabindex="1"
          (change)="changeSelect()"
          [(ngModel)]="partiesSelected"
          style="flex: 1;">
        </ng-select>
 
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <button class="btn btn-primary btn-sm" (click)="onNewParty()">
        <i class="fas fa-plus"></i> Nuevo Socio
      </button>
      @if (!appSettings.isMobile()) {
        <button type="button"
          class="btn btn-outline-secondary btn-sm"
          [class.btn-outline-primary]="activeAdvancedFiltersCount() > 0"
          title="Filtros avanzados"
          (click)="onOpenFilters()">
          <i class="fas fa-filter"></i> Filtros
          @if (activeAdvancedFiltersCount() > 0) {
            <span class="badge bg-primary ms-1">{{ activeAdvancedFiltersCount() }}</span>
          }
        </button>
      }
    </div>

    <div class="party-cards-scroll desktop-cards-scroll">
      <ng-container *ngTemplateOutlet="partyCards"></ng-container>
    </div>
    <div class="pt-2 text-center text-muted small">
      Total Registros: {{ parties()?.length || 0 }}
    </div>
  </div>
} @else {
  <div class="mobile-parties-container">
    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
      <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading()) { ({{ parties()?.length || 0 }}) }
      </span>
      @if (!isPortalUser()) {
        <button type="button" class="btn btn-xs btn-white shadow-sm border d-flex align-items-center gap-1"
                (click)="onNewParty()">
          <i class="fas fa-plus"></i>
          <span>Nuevo</span>
        </button>
      }
    </div>

    <div class="party-cards-scroll mobile-cards-scroll">
      <ng-container *ngTemplateOutlet="partyCards"></ng-container>
    </div>
  </div>
}

<ng-template #partyCards>
  @if (isLoading()) {
    @for (i of [1, 2, 3, 4, 5]; track $index) {
      <app-list-card [isLoading]="true"></app-list-card>
    }
  } @else {
    @for (r of parties(); track r.uuid || r.id) {
      <app-list-card
        [isShortcut]="appSettings.isMobile()"
        [customClass]="selectedUuid() === r.uuid ? 'list-card-selected' : ''"
        (click)="onSelectParty(r)">
        <div cardTitle class="fw-bold text-dark text-truncate">
          {{ r.partyNames }}
        </div>
        @if (r.entityCode) {
          <span cardBadge class="badge bg-secondary">{{ r.entityCode }}</span>
        }
        <div class="text-muted small">
          <i class="fas fa-id-card me-1"></i>{{ r.partyRut || r.rut }}
        </div>
        <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
          ESTADO
        </span>
        <div cardAmount>
          <span class="badge border" [ngClass]="r.status?.style">{{ r.status?.name || r.statusName }}</span>
        </div>
      </app-list-card>
    }
  }

  @if (!isLoading() && !parties()?.length) {
    <div class="card border-0 shadow-sm p-4 text-center my-2">
      <i class="fas fa-users fa-3x text-muted opacity-50 mb-2"></i>
      <h6 class="text-muted mb-1">No se encontraron socios</h6>
      <small class="text-muted">Ajusta los filtros para ver más resultados.</small>
    </div>
  }
</ng-template>
